var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpenBookDecor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 609,
    height: 413,
    viewBox: "0 0 609 413",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_29_574)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M604.393 404.204C496.36 358.458 398.616 360.208 306.547 388.148C164.695 363.404 67.558 367.246 5.24632 404.273L5.2594 289.341L604.406 289.272L604.393 404.204Z",
    fill: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.398 372.758C504.871 327.632 405.461 324.729 304.546 372.792C201.193 343.019 101.278 343.342 4.69428 372.826L4.73411 22.9332C107.422 -7.7528 207.307 -7.02705 304.586 22.899C407.351 -6.94643 507.391 -7.904 604.437 22.8649L604.398 372.758Z",
    fill: "#E3F2FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7218 66.4306L28.3738 57.8389C29.6865 57.3247 61.0524 45.1669 107.083 38.9619C149.641 33.2239 213.045 31.848 273.429 57.8696L269.793 66.3444C211.428 41.1936 149.898 42.5253 108.558 48.07C63.5617 54.1067 32.035 66.3078 31.7218 66.4306Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7182 98.4336L28.3702 89.9192C29.6828 89.4096 61.0488 77.3612 107.08 71.2119C149.637 65.5261 213.041 64.1624 273.425 89.9493L269.789 98.3479C211.424 73.4234 149.895 74.7421 108.555 80.2381C63.5581 86.2205 32.0314 98.3119 31.7182 98.4336Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7145 130.715L28.3665 122.123C29.6792 121.609 61.0451 109.451 107.076 103.246C149.633 97.5078 213.037 96.1319 273.422 122.153L269.785 130.628C211.42 105.478 149.891 106.808 108.551 112.354C63.5544 118.391 32.0277 130.592 31.7145 130.715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7109 162.996L28.3628 154.404C29.6755 153.89 61.0414 141.732 107.072 135.527C149.63 129.79 213.034 128.412 273.418 154.435L269.782 162.91C211.417 137.758 149.887 139.09 108.547 144.635C63.5507 150.672 32.024 162.873 31.7109 162.996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7072 195.277L28.3592 186.685C29.6718 186.171 61.0378 174.013 107.069 167.808C149.626 162.07 213.03 160.694 273.414 186.716L269.778 195.191C211.413 170.039 149.884 171.371 108.544 176.916C63.5471 182.953 32.0203 195.154 31.7072 195.277Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7035 227.558L28.3555 218.966C29.6682 218.452 61.0341 206.294 107.065 200.089C149.622 194.352 213.026 192.975 273.411 218.997L269.774 227.472C211.409 202.32 149.88 203.652 108.54 209.197C63.5434 215.234 32.0167 227.435 31.7035 227.558Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.698 22.9868L303.473 22.9871L303.433 371.679L305.659 371.679L305.698 22.9868Z",
    fill: "#CBCBCB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_29_574",
    x: 0.694336,
    y: 0.150146,
    width: 607.743,
    height: 412.123,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_29_574"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_29_574",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenBookDecor);
export default __webpack_public_path__ + "static/media/OpenBookDecor.e26790daf300171a31512da5d9f5555a.svg";
export { ForwardRef as ReactComponent };